
export const getNYRebateTotal = (state) => {
    const { systemSize } = state.solar;
    const { nyRebate } = state.nyserda;
    const { projectState } = state.projectaddress;

    let sum = 0;

    if (projectState === 4 && nyRebate) {
        sum = systemSize * nyRebate;
    }

    return sum;
};

export const getNYPTaxAbatement = (state, year) => {
    const { projectState } = state.projectaddress;
    const { cashprice } = state.solar;

    let cashAbatement = 0;

    if (projectState === 4 && year <= 4) {
        cashAbatement = (cashprice - getNYRebateTotal(state)) * 0.2;
    }
    if (cashAbatement > 250000 && year <= 4) {
        cashAbatement = 250000;
    }

    return cashAbatement;
};


export const getNYPTaxAbatementMosaic = (state, year) => {
    const { projectState } = state.projectaddress;
    const { cashprice } = state.solar;
    const { mosaicFee, loanProvider, showLoan } = state.loan;

    let mosaicAbatement = 0;
    const rebate = getNYRebateTotal(state);


    if (projectState === 4 && year <= 4 && loanProvider === 'mosaic' && showLoan) {
        mosaicAbatement = ((cashprice * mosaicFee) - rebate) * 0.20;
    }
    if (mosaicAbatement > 250000 && year <= 4) {
        mosaicAbatement = 250000;
    } if (year > 4) {
        mosaicAbatement = 0;
    }
    return mosaicAbatement;
};


export const getNYResiTaxCredit = (state, year) => {
    const { resiToggle } = state.tax;
    const { projectState } = state.projectaddress;
    const { cashprice } = state.solar;
    const { mosaicFee, loanProvider, showLoan } = state.loan;
    const { selectedFinancing } = state.settings;


    const rebate = getNYRebateTotal(state, year);

    let sum = 0;

    if (year > 1 || resiToggle === false || projectState !== 4) {
        return sum;
    }

    if (resiToggle && projectState === 4 &&
        selectedFinancing === 2 && loanProvider === 'mosaic' &&
        showLoan) {
        sum = (cashprice * mosaicFee - rebate) * 0.20;
    }
    if (resiToggle && projectState === 4) {
        sum = (cashprice - rebate) * 0.20;
    }

    let stateCredit = 0;

    if (sum > 5000) {
        stateCredit = 5000;
    } else {
        stateCredit = sum;
    }

    return stateCredit;
};



// WEBPACK FOOTER //
// ./src/containers/common/nyserda/selectors.js